import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { finalize, switchMap, tap } from 'rxjs/operators';

import { ErrorHandlerService, AuthenticationService, NotyService, ResetPasswordContext, EnterpriseService } from '@app/services';
import { TranslateService } from '@ngx-translate/core';
import { from } from 'rxjs';

@Component({
  selector: 'app-auth-password-edit',
  templateUrl: './auth-password-edit.component.html',
  styleUrls: ['../auth.scss', './auth-password-edit.component.scss'],
  standalone: false
})
export class AuthPasswordEditComponent implements OnInit {
  form!: UntypedFormGroup;
  isLoading = false;

  constructor(
    public enterpriseService: EnterpriseService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private authenticationService: AuthenticationService,
    private errorHandlerService: ErrorHandlerService,
    private notyService: NotyService,
    private translateService: TranslateService
  ) {
    this.form = this.formBuilder.group({
      email: this.route.snapshot.queryParams.email,
      token: this.route.snapshot.params.token,
      password: '',
      password_confirmation: ''
    } as ResetPasswordContext);
  }

  ngOnInit() {
    this.authenticationService.logout().subscribe();
  }

  resetPassword() {
    this.isLoading = true;
    this.form.markAllAsTouched();

    this.authenticationService
      .resetPassword(this.form.value)
      .pipe(
        finalize(() => (this.isLoading = false)),
        tap(() => {
          this.notyService.success(this.translateService.instant('notyService.passwordChangedSuccess'));
        }),
        switchMap(() => this.authenticationService.logout()),
        switchMap(() =>
          from(
            this.router.navigate(['/entrar'], {
              replaceUrl: true,
              queryParams: { email: this.form.get('email').value }
            })
          )
        )
      )
      .subscribe({
        error: error => this.errorHandlerService.handleValidation(this.form, error)
      });
  }
}
